import React, { useEffect, useMemo, useState } from 'react'
import { Drawer, InputNumber, Input, Form } from 'antd'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../../components'

const CURRENCY_BY_COUNTRY = { MX: 'MXN', BR: 'BRL', CO: 'COP', CL: 'CLP' }

export const ConfigureShippingCostPanel = ({
  open,
  tarifZone,
  country,
  remediation, // unused for now; kept in signature
  draftCosts,
  onAppend,
  onClose,
}) => {
  const { t } = useTranslation()
  const [cost, setCost] = useState(null)
  const [maxWeight, setMaxWeight] = useState(null)
  const [currency, setCurrency] = useState(CURRENCY_BY_COUNTRY[country] || '')

  useEffect(() => {
    if (!open) {
      setCost(null)
      setMaxWeight(null)
      setCurrency(CURRENCY_BY_COUNTRY[country] || '')
    }
  }, [open, country])

  const existingDraft = useMemo(() => (draftCosts || []).find(c => c.tarif_zone === tarifZone), [draftCosts, tarifZone])

  // Both cost and max_compound_weight must be > 0: the runtime rate lookup filters
  // `cost > 0` and `max_compound_weight >= weight` (a NULL/0 ceiling never matches), so a
  // cost without a positive weight ceiling would create an unreachable, "disabled"-looking
  // tier. Mirrors ShippingCosts::BulkCreateValidator.
  const canAdd = typeof cost === 'number' && cost > 0 && typeof maxWeight === 'number' && maxWeight > 0 && tarifZone

  return (
    <Drawer open={open} onClose={onClose} title={t('coberturas.createCoverages.configureCost.title', { zone: tarifZone })} width={420} destroyOnClose>
      <p className="text-sm text-gray-600 mb-3">{t('coberturas.createCoverages.configureCost.help', { zone: tarifZone })}</p>

      <Form layout="vertical">
        <Form.Item label="tarif_zone">
          <Input value={tarifZone} disabled />
        </Form.Item>
        <Form.Item label={t('coberturas.createCoverages.configureCost.cost')} required>
          <InputNumber value={cost} onChange={setCost} step={0.01} precision={2} min={0} className="w-full" />
        </Form.Item>
        <Form.Item label={t('coberturas.createCoverages.configureCost.maxWeight')} required>
          <InputNumber value={maxWeight} onChange={setMaxWeight} step={0.1} precision={1} min={0} className="w-full" />
        </Form.Item>
        <Form.Item label={t('coberturas.createCoverages.configureCost.currency')}>
          <Input value={currency} onChange={e => setCurrency(e.target.value)} placeholder="MXN" />
        </Form.Item>
      </Form>

      {existingDraft && (
        <div className="text-xs text-gray-500 mb-2">
          {t('coberturas.createCoverages.configureCost.alreadyQueued', {
            cost: existingDraft.cost,
            currency: existingDraft.currency_code || currency,
          })}
        </div>
      )}

      <div className="flex justify-end gap-2 mt-6">
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button
          type="primary"
          disabled={!canAdd}
          onClick={() => {
            onAppend({
              tarif_zone: tarifZone,
              cost,
              max_compound_weight: maxWeight,
              currency_code: currency || undefined,
            })
            onClose()
          }}
        >
          {t('coberturas.createCoverages.configureCost.add')}
        </Button>
      </div>
    </Drawer>
  )
}
